<script lang="ts" setup>
import { type VariableStateKey, getVariableToRefs } from '@/global-variable'

defineOptions({ name: 'Spin' })
const props = withDefaults(defineProps<{
  scope: VariableStateKey
}>(), {})

const spinValue = getVariableToRefs(props.scope)
</script>

<template>
  <a-spin :loading="spinValue">
    <slot />
  </a-spin>
</template>

<style lang="less" scoped>

</style>
